import configJson from '../config/config.json';

const appConfig = {
    lastUpdate: configJson.lastUpdate,
    environmentName: configJson.environmentName,
    baseApiUrl: configJson.apiBaseUrl,
    aemHeaderUrl: configJson.aemHeaderUrl,
    aemFooterUrl: configJson.aemFooterUrl,
    logRocketId: configJson.logRocketId
};

const azureB2CConfig = {
    auth: {
        clientId: configJson.azureB2CConfig.auth.clientId,
        authority: configJson.azureB2CConfig.auth.authority,
        knownAuthorities: configJson.azureB2CConfig.auth.knownAuthorities,
        redirectUri: configJson.azureB2CConfig.auth.redirectUri,
        postLogoutRedirectUri: configJson.azureB2CConfig.auth.postLogoutRedirectUri
    },
    cache: {
        cacheLocation: configJson.azureB2CConfig.cache.cacheLocation,
        storeAuthStateInCookie: configJson.azureB2CConfig.cache.storeAuthStateInCookie
    }
};

const azureADConfig = {
    auth: {
        clientId: configJson.azureADConfig.auth.clientId,
        authority: configJson.azureADConfig.auth.authority,
        redirectUri: configJson.azureADConfig.auth.redirectUri,
        postLogoutRedirectUri: configJson.azureADConfig.auth.postLogoutRedirectUri
    },
    cache: {
        cacheLocation: configJson.azureADConfig.cache.cacheLocation,
        storeAuthStateInCookie: configJson.azureADConfig.cache.storeAuthStateInCookie
    }
};

const azureB2CScope = {
    scopes: configJson.azureB2CConfig.scope.scopes
};

const azureADScope = {
    scopes: configJson.azureADConfig.scope.scopes
};

const ConfigService = {
    appConfig,
    azureB2CConfig,
    azureADConfig,
    azureB2CScope,
    azureADScope
};

export default ConfigService;
